
    import Vue from "vue";
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
    import {MedicalCertificateListItem, ValidityStatus} from "@/api-client";
    import {formatDate} from "@/formatting/dateFormatter";
    import ClientsidePaging from "@/components/ClientsidePaging";
    import {BvTableFieldArray} from "bootstrap-vue";
    import ValidityStatusBadge from "@/features/shared/components/ValidityStatusBadge.vue";
    import {ls} from "@/CultureService";
    import ClientsidePagingSelector from "@/components/ClientsidePagingSelector.vue";

    @Component({
        components: {
            ValidityStatusBadge,
            TableEmptySlot,
            ClientsidePagingSelector
        }
    })
    export default class MedicalCertificatesTable extends Vue {
        @Prop({ required: true})
        medicalCertificates!: MedicalCertificateListItem[];
        @Prop({ default: false})
        withPagination!: boolean;
        @Prop({ required: true})
        seafarerId!: string;

        paging = new ClientsidePaging();

        showRestrictionDetails() {
            this.medicalCertificates.forEach(item =>
                (item as any)._showDetails = true
            )
        }

        async created() {
            this.showRestrictionDetails();
        }

        async beforeUpdate() {
            this.showRestrictionDetails();
        }

        navigateToDetails(item: MedicalCertificateListItem) {
            this.$router.push({ name: "medical-certificate-details", params: { seafarerId: this.seafarerId, id: item.id } });
        }
        fields: BvTableFieldArray = [
            {
                key: "medicalInstitutionName",
                label: this.$ls.PersonProfile_MedicalCertificates_Table_Label_MedicalInstitution,
                sortable: true,
            },
            {
                key: "medicalPractitionerFullName",
                label: this.$ls.PersonProfile_MedicalCertificates_Table_Label_MedicalPractitioner,
                sortable: true,
            },
            {
                key: "positionName",
                label: this.$ls.PersonProfile_MedicalCertificates_Table_Label_Position,
                sortable: true,
            },
            {
                key: "issuedAt",
                label: this.$ls.Global_Label_IssueDateShort,
                sortable: true,
                formatter: (dateString: string): string => formatDate(dateString),
            },
            {
                key: "validUntil",
                label: this.$ls.Global_Label_ValidUntil,
                sortable: true,
                formatter: (dateString: string): string => formatDate(dateString),
            },
            {
                key: "status",
                label: this.$ls.Global_Label_DocumentState,
                sortable: true,
                sortByFormatted: true,
                thClass: "w-10",
                formatter: (value: ValidityStatus): string => {
                    switch (value) {
                        case ValidityStatus.Unchecked:
                            return ls.Global_ValidityState_Unchecked;
                        case ValidityStatus.Valid:
                            return ls.Global_ValidityState_Valid;
                        case ValidityStatus.Invalid:
                            return ls.Global_ValidityState_Invalid;
                        default:
                            return value;
                    }
                },
            },
            {
                key: "linkIcon",
                label: "",
                sortable: false,
                tdClass: "table-actions",
                thClass: "w-5",
            },
        ];
    }
